import { render, staticRenderFns } from "./personnelOverview_detailActivity.vue?vue&type=template&id=195cb0d6&scoped=true&"
import script from "./personnelOverview_detailActivity.vue?vue&type=script&lang=js&"
export * from "./personnelOverview_detailActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195cb0d6",
  null
  
)

export default component.exports